import React, { useState, useEffect } from 'react';
import { useStateSelector } from '../../../../store/selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';
import PortalTooltip from '../../../../components/PortalTooltip/PortalTooltip';
import { DocumentInfo } from '../../../../models/DocumentInfo/DocumentInfo';
import moment from 'moment';
import '../../../../components/DocumentListCard/DocumentListCard.scss';
import '../../../../components/DocumentTile/DocumentTile.scss';
import './ConnectMarketplaceAgreements.scss';
import { SignedBuyerNda } from '../../../../slices/marketplace/timeline/models/signed-buyer-nda.model';
import { useLegalDocument } from '../../../../custom-hooks/useLegalDocument';
import { LegalDocumentType } from '../../../../models/LegalDocuments/legal-document-type.enum';

const ConnectMarketplaceAgreements = () => {
    const axios = useStateSelector((state) => state.core.axios);
    const [ndaDocuments, setNdaDocuments] = useState<DocumentInfo[]>([]);
    const { documentUrl: buyerTermsUrl } = useLegalDocument(
        LegalDocumentType.BuyersTermsOfService,
        axios
    );

    const getDocuments = async () => {
        const newDocumentList: DocumentInfo[] = [];

        try {
            const response = await axios.get('/api/Marketplace/MarketplaceBuyersNda/signed');
            const signedNdas: SignedBuyerNda[] = response.data || [];

            signedNdas.forEach((nda) => {
                newDocumentList.push({
                    name: nda.documentName,
                    source: nda.documentFileUrl,
                    date: nda.documentSignedDate
                        ? new Date(nda.documentSignedDate)
                        : undefined,
                });
            });
        } catch (error) {
            console.log('Error checking buyer NDA status:', error);
        }

        setNdaDocuments(newDocumentList);
    };

    const getTooltipId = (index: number, name: string) => {
        return `agreement-tooltip-${index}-${name.replace(/\s+/g, '-')}`;
    };

    const openFile = (source: string) => {
        window.open(source, '_blank');
    };

    useEffect(() => {
        getDocuments();
    }, []);

    const documentList: DocumentInfo[] = [
        ...ndaDocuments,
        ...(buyerTermsUrl ? [{
            name: 'Connect Buyers TOS Addendum',
            source: buyerTermsUrl,
            date: new Date('2026-01-30'),
        }] : []),
    ];

    return (
        <div className="connect-marketplace-agreements">
            <div className="documents-container">
                {documentList.map((item, index) => (
                    <div
                        key={`document-${index}-${item.name}`}
                        style={{ width: 142, height: 60 }}
                        className="document-tile"
                        onClick={() => openFile(item.source)}>
                        <div className="icon-container">
                            <FontAwesomeIcon
                                inverse
                                className="icon"
                                icon={faFileAlt as any}
                            />
                        </div>
                        <div className="file-info">
                            <div>
                                <div 
                                    className="file-name"
                                    id={getTooltipId(index, item.name)}>
                                    {item.name}
                                </div>
                                {item.date ? (
                                    <div className="file-date">
                                        {moment(item.date).format('L')}
                                    </div>
                                ) : null}
                            </div>
                            <PortalTooltip
                                anchorId={getTooltipId(index, item.name)}
                                delayShow={300}
                                place="top"
                                content={item.name}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ConnectMarketplaceAgreements;
